import { api } from '../config/api';

export interface ExpenseTag {
  id: number;
  name: string;
  color: string;
  created_at: string;
  updated_at?: string;
}

export interface ExpenseTagCreate {
  name: string;
  color?: string;
}

export interface TagStats {
  id: number;
  name: string;
  color: string;
  expense_count: number;
  total_amount: number;
}

export interface TagStatsResponse {
  tags: TagStats[];
  grand_total?: number;
}

class ExpenseTagsService {
  async getTags(): Promise<ExpenseTag[]> {
    const response = await api.get<ExpenseTag[]>('/expense-tags/');
    return response.data;
  }

  async createTag(tag: ExpenseTagCreate): Promise<ExpenseTag> {
    const response = await api.post<ExpenseTag>('/expense-tags/', tag);
    return response.data;
  }

  async deleteTag(tagId: number): Promise<void> {
    await api.delete(`/expense-tags/${tagId}`);
  }

  async getTagStats(tagIds?: number[]): Promise<TagStatsResponse> {
    const params = tagIds?.length ? { tag_ids: tagIds } : {};
    const response = await api.get<TagStatsResponse>('/expense-tags/stats', { params });
    return response.data;
  }

  async addTagToExpense(expenseId: number, tagId: number): Promise<void> {
    await api.post(`/expenses/${expenseId}/tags/${tagId}`);
  }

  async removeTagFromExpense(expenseId: number, tagId: number): Promise<void> {
    await api.delete(`/expenses/${expenseId}/tags/${tagId}`);
  }
}

export const expenseTagsService = new ExpenseTagsService();